var map = {
	"./Home": [
		8525,
		525
	],
	"./Home/": [
		8525,
		525
	],
	"./Home/index": [
		8525,
		525
	],
	"./Home/index.tsx": [
		8525,
		525
	],
	"./Services": [
		3366,
		366
	],
	"./Services/": [
		3366,
		366
	],
	"./Services/index": [
		3366,
		366
	],
	"./Services/index.tsx": [
		3366,
		366
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;